var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-page-settings.ts
import { logger } from "@adornis/base/logging.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import { XSnackbar } from "@adornis/chemistry/elements/components/x-snackbar.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import "@adornis/fonts/fonts.js";
import { FormController } from "@adornis/forms/x-form-controller.js";
import "@adornis/forms/x-input.js";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { firstValueFrom, map, timer } from "rxjs";
import { PageMetaData } from "../../db/Page.js";
import "./x-buildify-color-picker.js";
import { drawerWrapper } from "./x-buildify-drawer-wrapper.js";
import "./x-icon-button.js";
var defaultPageSettingsConfig = {
  editor: (host) => xComponents(html`
      <x-flex space="xs">
        <x-input placeholder="Name" ${host._form.field("name")}></x-input>
        <x-text tone="subtle"> Pfad: ${host.page.value?.path} </x-text>
      </x-flex>
      <x-buildify-color-picker
        clearable
        placeholder="Hintergrund-Farbe"
        ${host._form.field("metaData", "backgroundColor")}
      ></x-buildify-color-picker>
      <x-buildify-color-picker
        clearable
        placeholder="Textfarbe"
        ${host._form.field("metaData", "color")}
      ></x-buildify-color-picker>
    `)
};
var XBuildifyPageSettings = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.page = new RXController(this, null);
    this.pageSettingsConfig = defaultPageSettingsConfig;
    this._form = new FormController(
      this,
      this.page.observable.pipe(
        map((page) => {
          if (page && !page.metaData)
            page.metaData = new PageMetaData({});
          return page;
        })
      ),
      {
        success: async (page) => {
          try {
            await XNativeDialog.waitFor(Promise.all([firstValueFrom(timer(150)), page.save()]));
            void XSnackbar.show("Seite wurde erfolgreich gespeichert");
            this.dispatchEvent(new CustomEvent("success", { detail: { value: this.page.value } }));
          } catch (err) {
            logger.error({ err }, "Es gab ein Problem beim Speichern der Buildify Page");
            void XNativeDialog.alert(
              "Es gab ein Problem beim Speichern der Seite. Bitte versuchen Sie es sp\xE4ter erneut."
            );
          }
        }
      }
    );
  }
  render() {
    const pageSettingsConfig = this.pageSettingsConfig ?? defaultPageSettingsConfig;
    return xComponents(html`
      ${drawerWrapper({
      title: "Seiten Einstellungen",
      content: () => pageSettingsConfig.editor(this),
      cancel: () => this.dispatchEvent(new CustomEvent("cancel")),
      deleteEntity: async () => {
        if (!await XNativeDialog.confirm("Wollen Sie dieses Element wirklich l\xF6schen?"))
          return;
        try {
          if (!this.page.value)
            return;
          await XDialog.waitFor(Promise.all([firstValueFrom(timer(150)), this.page.value.remove()]));
          void XSnackbar.show("Seite wurde erfolgreich gel\xF6scht");
        } catch (err) {
          logger.error({ err }, "Es gab ein Problem beim L\xF6schen einer Buildify Page");
          void XNativeDialog.alert(
            "Es gab ein Problem beim L\xF6schen dieser Seite. Bitte versuchen Sie es sp\xE4ter erneut."
          );
        }
      },
      validate: () => this._form.validate()
    })}
    `);
  }
  styles() {
    return [...super.styles(), { ":host": { height: "100%" } }];
  }
};
__decorateClass([
  property({ attribute: false })
], XBuildifyPageSettings.prototype, "page", 2);
__decorateClass([
  property({ attribute: false })
], XBuildifyPageSettings.prototype, "pageSettingsConfig", 2);
__decorateClass([
  state()
], XBuildifyPageSettings.prototype, "_form", 2);
XBuildifyPageSettings = __decorateClass([
  customElement("x-buildify-page-settings")
], XBuildifyPageSettings);
export {
  XBuildifyPageSettings,
  defaultPageSettingsConfig
};
